import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "kt_header",
  style: {},
  class: "header align-items-stretch"
}
const _hoisted_2 = {
  class: "d-flex align-items-center d-lg-none ms-n3 me-1",
  title: "Show aside menu"
}
const _hoisted_3 = {
  class: "btn btn-icon btn-active-light-primary",
  id: "kt_aside_mobile_toggle"
}
const _hoisted_4 = { class: "svg-icon svg-icon-2x mt-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center flex-grow-1 flex-lg-grow-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "d-lg-none"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "Logo",
      src: "/media/logos/hc.svg",
      class: "h-30px"
    })
  ])
], -1)
const _hoisted_6 = { class: "d-flex align-items-stretch justify-content-between flex-lg-grow-1" }
const _hoisted_7 = {
  class: "d-flex align-items-stretch",
  id: "kt_header_menu_nav"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["title"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["title"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "img rounded-circle w-40px d-grid bg-light",
  src: "/media/logos/machines/challs.png",
  alt: "",
  style: {"padding":"6px","box-shadow":"0 0 0 0 rgba(0, 0, 0, 1)","transform":"scale(1)","animation":"4s cubic-bezier(0.25, 0.1, 0.01, 0.96) 0s infinite normal none running pulse-green"}
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "d-flex align-items-stretch flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_KTTopbar = _resolveComponent("KTTopbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{
        'container-fluid': _ctx.headerWidthFluid,
        'container-xxl': !_ctx.headerWidthFluid,
      }, "d-flex align-items-stretch justify-content-between"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/abstract/abs015.svg" })
          ])
        ])
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_ctx.user.instance && (_ctx.user.instance?.machine_type != 'certification'))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "d-flex justify-content-center align-items-center cursor-pointer",
                title: _ctx.user.instance?.machine_name,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/laboratory/competition-machines/'+_ctx.user.instance.machine_id)))
              }, [
                _createElementVNode("img", {
                  class: "img rounded-circle w-40px d-grid",
                  src: _ctx.user.instance?.machine_avatar,
                  alt: "",
                  style: {"box-shadow":"0 0 0 0 rgba(0, 0, 0, 1)","transform":"scale(1)","animation":"4s cubic-bezier(0.25, 0.1, 0.01, 0.96) 0s infinite normal none running pulse-green"}
                }, null, 8, _hoisted_9)
              ], 8, _hoisted_8))
            : _createCommentVNode("", true),
          (_ctx.user.instance && (_ctx.user.instance?.machine_type == 'certification'))
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/certifications/certifications-machines/'+_ctx.user.instance.machine_id))),
                class: "d-flex justify-content-center align-items-center cursor-pointer",
                title: _ctx.user.instance?.machine_name
              }, [
                _createElementVNode("img", {
                  class: "img rounded-circle w-40px d-grid",
                  src: _ctx.user.instance?.machine_avatar,
                  alt: "",
                  style: {"box-shadow":"0 0 0 0 rgba(0, 0, 0, 1)","transform":"scale(1)","animation":"4s cubic-bezier(0.25, 0.1, 0.01, 0.96) 0s infinite normal none running pulse-green"}
                }, null, 8, _hoisted_11)
              ], 8, _hoisted_10))
            : _createCommentVNode("", true),
          (_ctx.user.instanceChallenge)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToActiveChallenge && _ctx.goToActiveChallenge(...args))),
                class: _normalizeClass(["d-flex justify-content-center align-items-center cursor-pointer", { 'ms-3': _ctx.user.instance }]),
                title: _ctx.user.instanceChallenge?.challenge_name
              }, _hoisted_14, 10, _hoisted_12))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_KTTopbar)
        ])
      ])
    ], 2)
  ]))
}